type CenteredContentProps = {
  children: React.ReactNode
}
export function CenteredContent({ children }: CenteredContentProps) {
  return (
    <div className="mx-auto box-content max-w-5xl px-4 md:px-6">{children}</div>
  )
}
